import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        // ZAPISANIE SESJI W PRZEGLĄDARCE
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userEmail', email);
        
        // PRZEKIEROWANIE DO DASHBOARDU
        navigate('/dashboard');
      } else {
        setMessage(data.error || "Nieprawidłowe dane logowania");
      }
    } catch (err) {
      setMessage("Błąd połączenia z serwerem");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f172a] px-6">
      <div className="max-w-md w-full bg-white/5 border border-white/10 p-10 rounded-3xl backdrop-blur-xl shadow-2xl">
        <h2 className="text-3xl font-black text-center mb-8 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
          Panel Klienta
        </h2>
        {message && (
          <div className="mb-6 p-3 bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-xl text-center">
            {message}
          </div>
        )}
        <form className="space-y-6" onSubmit={handleLogin}>
          <input 
            type="email" 
            className="w-full bg-black/20 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-cyan-500 outline-none transition" 
            placeholder="Email" 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            className="w-full bg-black/20 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-cyan-500 outline-none transition" 
            placeholder="Hasło" 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          <button type="submit" className="w-full py-4 bg-cyan-500 rounded-xl font-bold hover:bg-cyan-400 transition shadow-lg shadow-cyan-500/20">
            Zaloguj się
          </button>
        </form>
        <p className="mt-6 text-center text-gray-400 text-sm">
          Nie masz jeszcze konta? <Link to="/register" className="text-cyan-400 hover:underline">Zarejestruj się</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;